import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.public', {
        url: '/public',
        redirectTo: 'user.public.user-accounts',
        views: {
            '': 'userPublic',
        },
     
    })
}





// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/public.state.js